export default "__VITE_ASSET__c3108440__"